<template>

    <div id="item_widget">
        <div class="bg" :style="'background-image:url(' + item.pic_tumb + '), linear-gradient(to bottom, rgba(255, 255, 255, 0) 13%, #313030)'"></div>
        
        <div id="item_widget_content">
            <div class="head">
                <div class="soci right">
                    
                    <a @click="item.is_like ? doUnlike() : doLike()" :key="item.is_like" style="cursor:pointer;">
                        <i v-show="!item.is_like" class="far fa-heart"></i>
                        <i v-show="item.is_like" class="fas fa-heart" style="color:#d82c2c"></i>
                    </a>

                    <a :href="item.song_downloads.mp3.url" title="הורד לינקטון"><i class="fas fa-arrow-down"></i></a>
                    <a  title="שיתוף" @click="$bus.$emit('share_url', item.link)"><i class="fas fa-share"></i></a>
                    <!-- <a  title="הוספה לפלייליסט" @click="$bus.$emit('open_playlist_panel', item)"><i class="fas fa-list"></i></a> -->
                    <a  title="צפייה בגלרייה" @click="showGallery = true"><i class="fas fa-images"></i></a>

                </div>

                <router-link v-if="!unpublished && !is_mobile() && $route.name != 'item'" :to="'/linktone/' + item.id" class="border_btn expand_linktone">הצג לינקטון</router-link>
                <router-link v-if="item.artist && item.artist.has_lpedia == 1" :to="'/Artist/' + item.artist.id" class="border_btn linkipedia" @click="handleGoToLinkipedia">לינקיפדיה</router-link>
                <a v-if="!unpublished && $route.name != 'item'" class="go_back" @click="$emit('close')">סגור</a>
                <router-link v-if="!unpublished && $route.name == 'item' && get_me()" to="/" class="go_back">חזרה לקטלוג <i class="fas fa-arrow-left"></i></router-link>
            </div>
            <div class="menu">
                <ul>
                    <li v-for="item in menuComp" :key="item.name" :class="(item.is_active ? 'active' : '')"><a @click="set_active_page(item.content);" v-text="item.title"></a></li>
                </ul>
            </div>
            <div class="item_widget_content_scroll">

                <Head :item="item" />
                <div v-show="(currPage.content != 'Home' && enable_float) || currPage.content == 'Home'" :class="'big_video ' + (currPage.content == 'Home' ? '' : 'floating')" v-if="item.youtube_code != ''">
                    <a class="close" @click="$refs.video_player.player.pause(); enable_float=false">x</a>
                    <vue-plyr ref="video_player">
                    <div class="plyr__video-embed">
                        <iframe
                        :src="'https://www.youtube.com/embed/' + item.youtube_code + '?amp;iv_load_policy=3&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1&autoplay=' + item.bar_autoplay_video"
                        allowfullscreen
                        allowtransparency
                        allow="autoplay"
                        ></iframe>
                    </div>
                    </vue-plyr>

                </div>

                <component v-if="!isNull(item)" :is="currPage.content" :item="item" @movepage="set_active_page($event);" />
            </div>
        </div>
        <div :class="{active: showGallery}" class="linktone_gallery">
            <button id="btn_close_gallery" @click="showGallery = false">X</button>
            <swiper-container :navigation="true" slides-per-view="1" :loop="true" dir="rtl">
                <swiper-slide  v-for="galleryItem in item.gallery"  :key="galleryItem.id">
                    <div class="item" >
                        <div class="pic" :style="'background-image:url('+galleryItem.tumb_url+')'"></div>
                    </div>
                </swiper-slide>

            </swiper-container>
            <!-- <carousel :items-to-show="1" navigation :settings="{nav:true, rewind:true, loop:true}"  dir="rtl">
                <template #prev><span class="prev">prev</span></template>

                <slide v-for="galleryItem in item.gallery"  :key="galleryItem.id">
                    <div class="item" >
                        <div class="pic" :style="'background-image:url('+galleryItem.tumb_url+')'"></div>
                    </div>
                </slide>

                <template #next><span class="next">next</span></template>
            </carousel> -->
        </div>
    </div>
</template>

<script>
import Home from './home.vue'; 
import Lyrics from './lyrics.vue'; 
import Credits from './credits.vue'; 
import Downloads from './downloads.vue'; 
import Press from './press.vue'; 
import MoreItems from './more_items.vue'; 
import Head from './widget_head.vue'; 
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide/*, Pagination, Navigation*/ } from 'vue3-carousel'
// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();

export default {
  components: { Home, Lyrics, Credits, Downloads, Press, MoreItems,Head, Carousel, Slide },
  props: ["item","share_url" /*,"play_item"*/],
  data(){
    return {
        enable_float: true,
        showGallery: false,
        menu: [
            {title: 'ראשי', content: "Home", is_active: true},
            {title: 'מילים', content: "Lyrics", is_active: false, check(item){ return (item.songs.filter(row => row.lyrics != '').length > 0); }},
            {title: 'קרדיטים', content: "Credits", is_active: false, check(item){ return (item.credits != ''); }},
            {title: 'הורדות', content: "Downloads", is_active: false },
            {title: 'עיתונות', content: "Press", is_active: false, check(item){ return (item.press_pdf || item.has_communicate); }},
            {title: 'לינקטונים נוספים', content: "MoreItems", is_active: false}, 
        ]
    }
  },
  methods: {

      set_active_page(key)
      {
          this.menu.forEach(element => {
              element.is_active = (element.content == key);
          });
      },

      handleGoToLinkipedia(){
        if(this.is_mobile()) this.$emit('close');
      },
        
      doLike(){
        
        var self = this;
        this.api({ action: 'likes/add', data: { item_id: this.item.id }}, function(){ 

            self.item.is_like = true;
        });
      },
      doUnlike(){
        
        var self = this;
        this.api({ action: 'likes/remove', data: { item_id: this.item.id }}, function(){ 
            self.item.is_like = false;
        });
      }
  },
  
    computed:
    {
        unpublished(){
            return this.item && this.item.is_pending == '1';
        },
        menuComp(){
            if (this.item) return this.menu.filter((row) => {
                // console.log(this.item)
                // if (this.item?.id == '100013611') console.log(row)
                if (!this.isNull(row.check)) return row.check(this.item)
                return true;
            });
            else return this.menu;
        },
        currPage(){
            /*
            for (let i in this.menu)
            {
                if (this.menu[i].is_active == true) { return this.menu[i]; break; }
            }
            */

            return this.menu.find(element => element.is_active == true);
            //return this.menu[0]
        },
        is_video_playing(){
            if (this.$refs.video_player.length == 0) return false;

            console.log(this.$refs.video_player);

            return true;
        }
    },
    mounted(){
        this.$emit('playItem', this.item, (this.item.bar_autoplay_video == '0') );

        this.loaded=true;
        
        this.$nextTick(() => {

            if (this.$refs.video_player != undefined)
            { 
                this.$refs.video_player.player.on('play', () => { this.$bus.$emit('videoPlay'); });
        

                this.$bus.$on('audioPlay', () => {

                    if (this.item.youtube_code != '' && this.$refs.video_player != undefined) 
                    {
                        this.$refs.video_player.player.pause();
                    }

                });
            }
            //this.play_item = this.item;

            document.body.style.overflow = 'hidden';
            console.log(this.item);
        });
    },
    beforeUnmount(){
        this.$bus.$off('audioPlay');
        this.$emit('playItem', false);
        document.body.style.overflow = '';
    }
}
</script>

<style lang="scss" scoped>
#item_widget { 
    
    &{ width:var(--item_widget_width); max-width: 100vw; position: fixed; z-index: 100000; left: 0px; top: 0px; bottom: 0px; box-shadow: 21px 2px 78px 0 rgba(0, 0, 0, 0.63); background-color: #313030; 
        @media (min-width: 600px){ border-top-right-radius: 33px; }
        @media (max-width: 600px) {right: 0;}
    }
    .bg { position: absolute; z-index: 1; left: 0px; right: 0px; top: 0px; height: 50%; opacity: 0.7;  -webkit-filter: blur(30px); filter: blur(30px); /*background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 13%, #313030);*/ background-size:cover; }
    #item_widget_content { height: 100%; color: #fff; position: relative; z-index: 2; padding: 20px;}

    .linktone_gallery{transition: all .3s ease-in-out;position: absolute;
        @media (max-width: 600px) {inset: 0;z-index: 100000;}
        @media (min-width: 600px) {right: 0;top: 0;bottom: 0;width: calc(100vw - var(--item_widget_width));}
        &:not(.active){opacity: 0;pointer-events: none;}
        &.active{opacity: 1;
            @media (max-width: 600px) {}
            @media (min-width: 600px) {transform: translateX(100%);}
        }
        .item{width: 100%;background-color: #333;
            .pic{background-repeat: no-repeat;background-size:contain;background-position:center;width: 100%;height: 100vh;}
        }
        #btn_close_gallery{position: absolute;cursor: pointer; top: 20px;right: 20px;z-index: 999999; background-color: #fff;color: #000;font-size: 28px;border-radius: 100%;width: 40px;height: 40px;border: none;}
    }

    .expand_linktone{margin-left: 5px;
        @media (max-width: 600px) {display: none;}
        @media (min-width: 600px) {}
    }

    a.linkipedia{position: relative;border-color: transparent;
        &::before{  content: "";position: absolute;inset: 0;border-radius: 50px; padding: 1px; background:linear-gradient(135deg, #ff1661 13%, #00b7ff 123%);-webkit-mask:    linear-gradient(#fff 0 0) content-box,    linear-gradient(#fff 0 0);-webkit-mask-composite: xor;        mask-composite: exclude; }
        @media (max-width: 600px) {margin-bottom: 5px;}
        @media (min-width: 600px) {}
    }
    
    .go_back { float: left; color: #fff;}

    .menu { 
        &{ border-bottom: 1px solid rgba(255,255,255,0.3); overflow: hidden; line-height: 40px; margin-bottom: 20px; width: 100%;} 
        li { float: right; display: block; padding: 0 6px; } 
        li a { color: #fff; padding: 0 2px; display: block; position: relative; } 
        li:hover a, li.active a { &::after { content: ""; display: block; position: absolute; border-bottom: 1px solid #fff; bottom: 0px; left: 0px; width: 100%;} } 
    }
    
   .item_widget_content_scroll { 
    
        height: calc(100vh - 221px);
        overflow-y: auto;
        margin: 0 -20px;
        padding: 0 20px; padding-bottom: 150px;
    }

    .big_pic { display: block;  background-position: center center; background-repeat: no-repeat; background-size: cover; border-radius: 25px;   box-shadow: 0 12px 47px -4px rgba(0, 0, 0, 0.52);
    @media (max-width: 600px) {min-width: 300px; width: 100%;aspect-ratio: 1;}
    @media (min-width: 600px) {height: 300px;}
 }

    .big_video { 
        & { /*-moz-transition:all 0.3s ease 0s;-o-transition:all 0.3s ease 0s;-webkit-transition:all 0.3s ease 0s;transition:all 0.3s ease 0s*/}
        &.floating { position: fixed; right: 200px; bottom: 0px; width: 400px;

            @media (max-width: 600px){  display: none;} 

            .close { display: block; width: 30px; height: 30px; background:#fff; text-align: center; line-height: 30px; position: absolute; left: 0px; top: -30px; color: #000;}
        }
        &:not(.floating) .close { display: none;}
     }

 .soci {
     a { display: inline-block; width:30px; height: 30px; margin-left: 10px; text-align: center; line-height: 30px; color: #fff; border:1px solid #fff; border-radius: 100%; font-size: 13px;}
 }

 
  @media (max-width: 600px){
    & { z-index: 99999; }
  }

}
</style>